import React from "react";
import "./TonerCartridges.css";
import tonerImg from "../assets/toner1.png";
import tonerImgs from "../assets/toner2.png";

const TonerCartridges = () => {
  return (
    <div className="tonermain">
      <div className="toner-cards">

        <div className="toner-card">
          <img src={tonerImgs} alt="Toner Cartridges" />
          <h4>High page yield and smooth toner flow</h4>
        </div>
      </div>

      <div className="toner-section fade-in-up">
        <h2>Toner Cartridges</h2>
        <p>
          At Recla, we specialise in a complete range of new, compatible, and 
          remanufactured toner cartridges for leading brands such as Konica 
          Minolta, Canon, HP, Ricoh, Kyocera, Sharp, and Toshiba.
        </p>

        <p className="ps-note">
          Whether you’re a reseller, a corporate office, or a print service provider, 
          Recla cartridges deliver professional results every time.
          <br /><br />
          <strong>🟢 Bulk orders (50+ sets) available with special pricing.</strong>
        </p>
      </div>
    </div>
  );
};

export default TonerCartridges;
